// @flow

export const UPDATE_DOCUMENT_TITLE = 'UPDATE_DOCUMENT_TITLE';

export const MOUNT_POINT = 'documentTitle';
